import { useSignForm } from '@shared/components/forms/sign'
import { useFormik } from 'formik'

import { sendStep1SignForm } from './api'
import { View } from './view'

export const SignFormStep1 = () => {
	const { nextStep, setOptionalDocsIds } = useSignForm()

	const formik = useFormik({
		initialValues: {} as Record<string, boolean>,
		validateOnMount: true,
		enableReinitialize: true,

		async onSubmit(values, actions) {
			actions.setSubmitting(true)
			try {
				await sendStep1SignForm()
				setOptionalDocsIds(values)
				nextStep()
			} catch (error: any) {
				if (error?.status === 403) {
					alert('Документы уже подписаны')
				}

				actions.setSubmitting(false)
			}
		},
	})

	return View({
		formik,
	})
}
